<template>
  <div>
    <!-- 返回键 -->
    <div class="back" @click="back()">
      <i></i>
      <span>返回</span>
    </div>
    <div class="mian">
      <!-- 添加题库按钮 -->
      <h3 class="title">{{ AppClassName }}</h3>
      <div v-if="isaddtest">
        <div class="addtestbtn">
          <div class="addtestbtncontent1" @click="dialogVisible = true"></div>
        </div>
        <h4>添加题库</h4>
      </div>
      <div v-if="!isaddtest" class="editorcom">
        <TheEditor ref="thethree" :cutcoms="cutcoms"></TheEditor>
      </div>
    </div>

    <!-- 弹窗 -->
    <!-- 添加题库 -->
    <div class="everywhere">
      <el-dialog
        title="添加题库"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <div class="add_bank">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="题库名称：" prop="bankName">
              <el-input
                v-model.trim="ruleForm.bankName"
                placeholder="请输入题库名称"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="
              dialogVisible = false;
              ruleForm.bankName = '';
            "
            >取 消</el-button
          >
          <el-button type="primary" @click="determineAdd()"> 确 定 </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import TheEditor from "../components/detailTree.vue";
import loginvuex from "@/store/index";
import { ChapterManager, ChapterThree } from "@/api/quebankmana.js";
export default {
  data() {
    return {
      //  isloading:true,//动态渲染
      isaddtest: false,
      AppClassName: "", //题库的名称
      dialogVisible: false, // 弹窗
      ruleForm: {
        bankName: "",
      },
      towId: "",
      rules: {
        name: [{ required: true, message: "请输入题库名称", trigger: "blur" }],
      },
    };
  },
  components: {
    TheEditor,
  },
  props: ["cutcoms"],
  methods: {
    back() {
      this.cutcoms(0);
      this.$destroy();
    },

    async determineAdd() {
      let res = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        UserID: JSON.parse(loginvuex.state.userlist).userID,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
        Level: 1, //等级
        ChapterName: this.ruleForm.bankName, //试题名称
        AppID: -1,
        ParentID: this.$parent.TestID,
      };
      const Data = await ChapterManager(res);
      if (Data.status === 200) {
        this.towId = Data.data.Data.ID;
        this.$parent.bankName = this.ruleForm.bankName;
        this.dialogVisible = false;
        this.isaddtest = false;
      } else {
        this.dialogVisible = false;
        this.$message.error("很抱歉，数据异常");
      }
    },
  },
  async created() {
    // this.isloading= true
    // console.log(this.$parent.TestID);
    //   console.log(this.$parent.isselectitems.AppClassID);
    let res = {
      ClassID: this.$parent.isselectitems.AppClassID,
      guid: JSON.parse(loginvuex.state.userlist).guid,
      userID: JSON.parse(loginvuex.state.userlist).userID,
      hid: JSON.parse(loginvuex.state.hid),
    };
    const Data = await ChapterThree(res);
    console.log(Data, 0);
    this.$parent.TestID = Data.data.Data.TestLib[0].AppClassID;
    if (Data.data.Data.Three.length != 0) {
      this.isaddtest = false;
      // setTimeout(() => {
      //   this.isloading= false
      // }, 300);
      this.AppClassName = Data.data.Data.TestLib[0].AppClassName;
      this.isselectitemschilds = Data.data.Data.Three;
    } else {
      this.isaddtest = true;
      //this.isloading= false
      console.log(Data.data.Data.TestLib[0]);
      this.AppClassName = Data.data.Data.TestLib[0].AppClassName;
      console.log(this.AppClassName);
    }
  },
};
</script>

<style lang="scss" scoped>
.editorcom {
  width: 100%;
}
.back {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  border-radius: 0px 0px 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.mian {
  background: #ffffff;
  border-radius: 0px 0px 10px 10px;
  margin-top: 24px;
  min-height: 740px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .title {
    background: #ecf4ff;
    height: 80px;
    line-height: 80px;
    width: 100%;
    text-align: center;
  }
}
.addtestbtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 370px;
  padding-top: 80px;
  background-color: #ffffff;
  & + h4 {
    background-color: #ffffff;
    padding-bottom: 100px;
    text-align: center;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #1890ff;
    cursor: pointer;
  }
  .addtestbtncontent1 {
    width: 200px;
    height: 200px;
    background-image: url("../../../../assets/addtesttype.png");
    background-size: 100%;
    cursor: pointer;
    &:hover {
      width: 290px;
      height: 290px;
      background-image: url("../../../../assets/addtesttypeactive.png");
      background-size: 100%;
    }
  }
}
// 弹窗样式
.everywhere {
  ::v-deep .el-dialog {
    width: 552px !important;
    height: 240px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog__body {
    padding: 24px;
  }
  ::v-deep .el-dialog__header {
    height: 55px;
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    ) !important;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    button:nth-child(1) {
      margin-right: 50px;
    }
  }
  p {
    text-align: center;
    font-size: 16px;
  }
  ::v-deep.el-form-item__label {
    width: 120px !important;
  }
  ::v-deep .el-form-item__content {
    margin-left: 120px !important;
  }
  ::v-deep.el-input__inner {
    width: 350px !important;
    height: 40px;
  }
}
</style>